// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".metadata-assign-icon{width:17.5px;height:17.5px;margin-right:5px}.metadata-property-grid .filter-by-status-dropdown-item .dropdown-item{display:flex !important}", ""]);
// Exports
module.exports = exports;
